module.exports = __webpack_public_path__ + "img/toaster.39ec4961.jpg";